import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoNuevoTucson from "../nuevotucson/InfoNuevoTucson";
const Footer = lazy(() => import('../footer/Footer'));
function NuevoTucson() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai Tucson, tu compañero ideal, 100% Europeo. Galardonado por su seguridad, rendimiento, equipamiento, tecnología, amplitud y confort. Un SUV premium"
        />
        <meta
          name="keywords"
          content="SUV, Hyundai, Hyundai Tucson, Tucson, seguro, amplio, alto, tecnológico, confortable"
        />
        <title>Hyundai Tucson</title>
      </Helmet>
      <Menu />
      <InfoNuevoTucson />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default NuevoTucson;